import { api } from '@utils/api/api'

export const getDocument = (documentId: string): Promise<string> => {
  return api.get(`/api/v1/documents/${documentId}`)
}

export const sendDocument = (documentId: string): Promise<void> => {
  return api.post(`/api/v1/documents/${documentId}/send`)
}
